<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Assigned Job Position">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete 
						:options="approvalStructures" 
						optionsLabel="name" 
						optionsKey="id" 
						label-cols-lg="12" 
						label="Job Position" 
						id="input-job-position" 
						size="sm" 
						:model.sync="model.approvalStructureId" 
						:isRequired="true" 
						:state="validateState('approvalStructureId')" 
						:errorMessage="getErrorMessage(errorMessage.approvalStructureId, 'approvalStructureId')"
						:selected="model.approvalStructure != null ? model.approvalStructure.name : ''" 
						@input="getApprovalStructures" />
				</b-col>
				<b-col cols="12" lg="6">
				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import UserRoleDetail from '@/models/UserRole/UserRoleDetail';
import UserRoleDetailFilter from '@/filters/UserRole/UserRoleDetailFilter';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureList from '@/models/ApprovalStructure/ApprovalStructureList';
import UserRole from '@/models/UserRole/UserRole';
import UserRoleFilter from '@/filters/UserRole/UserRoleFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Role from '@/models/Role/Role';
import RoleFilter from '@/filters/Role/RoleFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			approvalStructureId: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				approvalStructureId: { required : "Job Position is Required."},
			},
			approvalStructures : [],
			isBusy: false,
		}
	},
	methods : {
		getApprovalStructure : async function(id) {
			this.isBusy = true;
			UserRoleDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getApprovalStructure(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getApprovalStructures();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getApprovalStructure(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
